module.exports = "/typo3conf/ext/grbundle/Resources/Public/Dist/page-menu-aside.jpg";